import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { GeneralAction, ServerDataResponse } from '@models/models';
import { catchError, map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { MessageService } from '@services/helpers/message-service/message.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { ReportOverviewList } from '@models/admin/reports.model';

@Injectable()
export class ReportsOverviewDataProvider {
	reportsOverviewSubject: BehaviorSubject<
		ReportOverviewList
	> = new BehaviorSubject<ReportOverviewList>({
		reports: null
	});

	constructor(
		private http: HttpClient,
		private messageService: MessageService
	) {}

	getSettingsOverviewItems(): Observable<ReportOverviewList> {
		const url = '/api/admin/rest/reports';

		return this.http
			.get(url)
			.catch(error => {
				this.messageService.showToaster('e_0', 'general', error.error);
				return Observable.throw(error);
			})
			.pipe(
				map((res: ServerDataResponse<any>): any => res.data),
				map(data => {
					const reportsData = JSON.parse(JSON.stringify(data.reports));

					this.reportsOverviewSubject.next({
						reports: reportsData
					});

					return data;
				})
			);
	}

	updateData(action: GeneralAction, data: any): Observable<any> {
		return this.http.post(action.url, data).pipe(
			catchError((error): Observable<HttpErrorResponse> => {
				this.messageService.catchErrorFromBackend(error);
				return Observable.throw(error);
			})
		);
	}

	reportsOverview(): Observable<ReportOverviewList> {
		return this.reportsOverviewSubject.asObservable();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/admin/reports/reports-overview.data.service.ts